// Default bar configuration that can be spread into Bar components
export const defaultChartContainerClassName = "mx-auto h-[400px] aspect-auto";
export const defaultChartLegendClassName = "flex justify-end gap-6 pr-6 mb-4";

export const defaultBarProps = {
  radius: 8,
  barSize: 14,
  fill: "hsl(var(--chart-1))"
} as const;

export const defaultLineProps = {
  strokeWidth: 1,
  stroke: "hsl(var(--chart-3))",
  strokeLinecap: "round",
  animationDuration: 0,
  dot: { fill: "hsl(var(--chart-3))", strokeWidth: 2, r: 4 }
} as const;

export const defaultXAxisProps = {
  tickLine: false,
  axisLine: false,
  height: 60,
} as const;

export const defaultYAxisProps = {
  tickLine: false,
  axisLine: false,
  orientation: "right",
  width: 60,
} as const;


export const formatAxisAmount = (amount: number): string => {
  const absAmount = Math.abs(amount);

  if (absAmount >= 1000000) {
    return `${amount < 0 ? '-' : ''}${(absAmount / 1000000).toLocaleString('en-US')}M`;
  } else if (absAmount >= 1000) {
    return `${amount < 0 ? '-' : ''}${(absAmount / 1000).toLocaleString('en-US')}K`;
  } else {
    return amount.toLocaleString('en-US');
  }
};


export const TooltipLine = ({ color, label, value, hideColorDot = false }: { color: string | undefined, label: string | undefined, value: React.ReactNode | undefined, hideColorDot?: boolean }) => {
  return (
    <div className="flex items-center justify-center w-full">
      {!hideColorDot && <div
        className="size-2 shrink-0 rounded-xs bg-(--color-bg) mr-2"
        style={{ "--color-bg": color } as React.CSSProperties}
      />}
      <div className="mr-2">
        {label}
      </div>
      <div className="ml-auto flex items-center font-mono font-medium tabular-nums">
        {value}
      </div>
    </div>
  )
}
